module.exports = __webpack_public_path__ + "img/img27.e0dd1bb3.png";